"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiAlertProps = void 0;
var react_1 = __importDefault(require("react"));
var palette_1 = require("../../../theme/global/palette");
var Success_1 = __importDefault(require("@tdcerhverv/parrotfish/icons/Success"));
var Error_1 = __importDefault(require("@tdcerhverv/parrotfish/icons/Error"));
var Warning_1 = __importDefault(require("@tdcerhverv/parrotfish/icons/Warning"));
var Info_1 = __importDefault(require("@tdcerhverv/parrotfish/icons/Info"));
exports.MuiAlertProps = {
    iconMapping: {
        success: react_1.default.createElement(Success_1.default, { fill: palette_1.palette.success.dark }),
        error: react_1.default.createElement(Error_1.default, { fill: palette_1.palette.error.dark }),
        warning: react_1.default.createElement(Warning_1.default, { fill: palette_1.palette.warning.dark }),
        info: react_1.default.createElement(Info_1.default, { fill: palette_1.palette.info.dark }),
    },
};
